export default __webpack_public_path__ + "static/media/investment-icon.a40db3f2.png";